{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-24T08:16:29.913Z","source":"place-details"}